import React from 'react';
// import PropTypes from 'prop-types';
import AutocodeSelectionAction from '../../AutocodeSelectionBox/AutocodeSelectionActions';
import { useACSelectionBoxContext } from '../../ACContext/ACSelectionBoxContext';
import { useACEditContext } from '../../ACContext/ACEditContext';
import { useACProjectContext } from '../../ACContext/ACDefinitionContext';
import { getNodeObjectsForDefinitionObjects } from '../../../../util/autocodeUtils';
import { CO1_DEF_EDIT, COMPOSER_SUBMODULE } from '../../../../trackerConstants';

const EditExpressionTarget = () => {
  const {
    moduleStudy,
    activeAccountId,
    uid,
    defDataPoints,
  } = useACProjectContext();

  const {
    seteditMode,
    setbackToDef,
    seteditFolderDetails,
  } = useACEditContext();

  const acSelContext = useACSelectionBoxContext();
  const { removeAllNodes, insertNodes, setSelectionBoxDefinitionNodes } = AutocodeSelectionAction(
    acSelContext.state,
    acSelContext.dispatch
  );

  const handleEditDefClick = async () => {
    seteditMode(true);
    setbackToDef(false);
    seteditFolderDetails([...defDataPoints]);
    acSelContext.state.setTabsIndex(0);

    // User tracking for edit definition
    acSelContext.trackerFn({ action: CO1_DEF_EDIT, subModule: COMPOSER_SUBMODULE });

    // Get node objects
    const nodes = await getNodeObjectsForDefinitionObjects(
      defDataPoints,
      uid,
      activeAccountId,
      moduleStudy.pn
    );
    setSelectionBoxDefinitionNodes(acSelContext.state.rootNode);
    // Clear SB and nodes
    removeAllNodes();
    insertNodes(nodes, '0', -1);
  };

  return (
    <button
      type="button"
      className="target-editexpression-definition"
      data-test="EditExpressionTarget"
      onClick={handleEditDefClick}
    >
      Edit Definition
    </button>
  );
};

EditExpressionTarget.propTypes = {};

export default EditExpressionTarget;
